(() => {
  const config = document.getElementById('lk-size-tooltip-config');
  if (!config) return;
  const settings = JSON.parse(config.textContent);
  const conversions = settings.conversions;
  const selector = '.globo-swatch-product-detail .swatch--gl';
  let scheduled = false;

  const updateGroup = (group) => {
    const name = group.querySelector('.name-option')?.getAttribute('data-name');
    if (!name || name.trim().toLowerCase() !== 'size') return;
    group.querySelectorAll('.select-option').forEach((option) => {
      const euSize = option.getAttribute('data-value')?.trim();
      const equivalents = ['kids', 'women', 'men'].flatMap((group) => {
        const size = conversions[group]?.[euSize];
        return size ? [settings[group + 'Label'].replace('[size]', size)] : [];
      });
      const text = equivalents.length ? settings.approximateUs.replace('[size]', equivalents.join('\n')) : settings.seeChart;
      const tooltip = option.querySelector('.attr-title-hover');
      if (tooltip && tooltip.textContent !== text) tooltip.textContent = text;
      const input = option.querySelector('input[type="radio"]');
      const description = settings.accessibleSize.replace('[eu]', euSize).replace('[us]', text);
      if (input && input.getAttribute('aria-label') !== description) input.setAttribute('aria-label', description);
    });
  };

  const update = () => {
    scheduled = false;
    document.querySelectorAll(selector).forEach(updateGroup);
  };

  new MutationObserver((mutations) => {
    if (scheduled || !mutations.some((mutation) =>
      mutation.type === 'childList' || mutation.attributeName === 'data-value' || mutation.attributeName === 'data-name'
    )) return;
    scheduled = true;
    requestAnimationFrame(update);
  }).observe(document.getElementById('MainContent') || document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['data-value', 'data-name'],
  });
  document.addEventListener('pointerover', (event) => {
    const group = event.target.closest?.(selector);
    if (group) updateGroup(group);
  }, true);
  document.addEventListener('focusin', (event) => {
    const group = event.target.closest?.(selector);
    if (group) updateGroup(group);
  });
  update();
})();

